export { graphql as orgmgrGql } from './orgmgr/index.js'
export { graphql as developerGql } from './developer/index.js'
export { getFragmentData, isFragmentReady } from './orgmgr/index.js'
export { getFragmentData as useFragment } from './orgmgr/index.js'

export type { FragmentType } from './orgmgr/index.js'
export type { GetVariableType } from '@nemlia/hasura-schema'
export type {ResultOf, VariablesOf} from '@graphql-typed-document-node/core'
export type {ResultOf as FragmentData} from '@graphql-typed-document-node/core'
export * as orgmgrTypes from './orgmgr/graphql.js'
export * as developerTypes from './developer/graphql.js'
